/* eslint-disable react/prop-types */

import React from 'react'
import { Row, Col, Checkbox } from 'antd'

export function PlotMenu () {
  return (
    <div className="upper-menu">
      <Row>
        <Col
          xs={{ span: 12, offset: 0, order: 1 }}
          lg={{ span: 3, offset: 1, order: 1 }}
        >
          <div className="label-box">
            <Checkbox
              style={{ fontSize: 'calc(12px + 0.4vw)' }}
              defaultChecked
              className="legend apruebo"
              name="apruebo"
              id="apruebo"
            >
              Apruebo
            </Checkbox>
          </div>
        </Col>

        <Col
          xs={{ span: 12, offset: 0, order: 1 }}
          lg={{ span: 3, offset: 1, order: 1 }}
        >
          <div className="label-box">
            <Checkbox
              style={{ fontSize: 'calc(12px + 0.4vw)' }}
              defaultChecked
              className="legend rechazo"
              name="rechazo"
              id="rechazo"
            >
              Rechazo
            </Checkbox>
          </div>
        </Col>

        <Col
          xs={{ span: 12, offset: 0, order: 1 }}
          lg={{ span: 5, offset: 1, order: 1 }}
        >
          <div className="label-box">
            <Checkbox
              style={{ fontSize: 'calc(12px + 0.4vw)' }}
              defaultChecked
              className="legend boric"
              name="boric"
              id="boric"
            >
              G. Boric (2V)
            </Checkbox>
          </div>
        </Col>

        <Col
          xs={{ span: 12, offset: 0, order: 1 }}
          lg={{ span: 6, offset: 1, order: 1 }}
        >
          <div className="label-box">
            <Checkbox
              style={{ fontSize: 'calc(12px + 0.4vw)' }}
              defaultChecked
              className="legend jak"
              name="jak"
              id="jak"
            >
              J. A. Kast (2V)
            </Checkbox>
          </div>
        </Col>
      </Row>
    </div>
  )
}
